export default __webpack_public_path__ + "static/media/Elder Wand - Img - Wip 2_02.1fa105a5.jpg";